import { useState } from "react";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { IoMdArrowDropdownCircle, IoMdArrowDropupCircle  } from "react-icons/io";
import moment from "moment";
import 'moment/locale/es';

import ExpandablePanel from '../../components/ExpandablePanel';
import { deadlineStatus, isProjectCancelled, isProjectFinished, projectStatusEnum, toolbarActions } from '../../services/EnumsService';
import ExpandableTaskComponent from '../Task/ExpandableTaskComponent';
import ToolbarComponent from '../toolbar/ToolbarComponent';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import { TaskModal } from '../Task/TaskModal';
import { ProjectModal } from "./ProjectModal";
import ProjectResourceComponent from "./ProjectResourceComponent";
import ProjectResourceModal from "./ProjectResourceModal";
import { projectOrderUp, projectOrderDown,projectStart,projectPause, projectFinish,projectCancel } from "../../api/project.api";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { showError } from "../../services/toastServices";
import { BulkTaskModal } from "../Task/BulkTaskModal";

export default function ExpandableProjectComponent({project, isFirst, isLast}) {
    const [showProjectModal, setShowProjectModal] = useState(false)
    const [showTaskModal, setShowTaskModal] = useState(false)
    const [showBulkTaskModal, setShowBulkTaskModal] = useState(false)
    const [showProjectResourceModal, setShowProjectResourceModal] = useState(false)
    const {category, refreshProjectsCategory} = CategoryData();

    const addTaskAction = (()=>{
        setShowTaskModal(true)
    })
    const addTaskCloseAction = (()=>{
        setShowTaskModal(false)
    })

    const bulkAddTaskAction = (()=>{
        setShowBulkTaskModal(true)
    })
    const bulkAddTaskCloseAction = (()=>{
        setShowBulkTaskModal(false)
    })

    const createProjectResourceAction = (()=>{
        setShowProjectResourceModal(true)
    })
    const createProjectResourceCloseAction = (()=>{
        setShowProjectResourceModal(false)
    })
    const editProjectAction = (()=>{
        setShowProjectModal(true)
    })
    const editProjectCloseAction = (()=>{
        setShowProjectModal(false)
    })

    const editProjectModal = (<ProjectModal projectId={project.id} closeAction={editProjectCloseAction}></ProjectModal>)
    const addTaskModal = (<TaskModal project={project} closeAction={addTaskCloseAction}></TaskModal>)
    const bulkAddTaskModal = (<BulkTaskModal project={project} closeAction={bulkAddTaskCloseAction}></BulkTaskModal>)
    const addProjectResourceModal = (<ProjectResourceModal project={project} closeAction={createProjectResourceCloseAction}></ProjectResourceModal>)
       
    const getDeadlineColor = (()=>{
        return deadlineStatus((moment(project.deadline).isAfter()))
    })
    const orderUp = (async ()=>{
        await projectOrderUp(project.id, orderError);
        refreshProjectsCategory();
    })

    const orderDown = (async ()=>{
        await projectOrderDown(project.id, orderError);
        refreshProjectsCategory();
    })

    const orderError = ((error)=>{
        showError(`Error al cambiar el orden del proyecto. ${error.message}`)

    })
    const changeStatusError = ((error)=>{
        showError(`Error al cambiar el estado del proyecto. ${error.message}`)

    })

    const renderUpButton = (()=>{
        if(isFirst)
            return (<div className="text-xl font-bold"><IoMdArrowDropupCircle color="gray"  /> </div>)
        else
            return (<div className="text-xl font-bold cursor-pointer" onClick={orderUp} ><IoMdArrowDropupCircle /> </div>)
    })

    const renderDownButton = (()=>{
        if(isLast)
            return (<div className="text-xl font-bold" ><IoMdArrowDropdownCircle color="gray" /></div>)
        else
            return (<div className="text-xl font-bold cursor-pointer" onClick={orderDown} ><IoMdArrowDropdownCircle /></div>)
    })
    const renderDeadline = (()=>{
        if(isProjectFinished(project) || isProjectCancelled(project)) return
        moment.locale('es')
        const text = `(deadline ${moment(project.deadline).endOf('day').fromNow()})`
        return(
            <div className='text-gray-400 text-right ml-2 px-2 rounded-md' style={{backgroundColor: `${getDeadlineColor()}`}}>{text}</div>
        )
    })

    const orderButtons = (
        <div className='flex flex-row'>
            <div className="flex flex-row mr-4">
                {renderUpButton()}
                {renderDownButton()}
            </div>
        </div>
    );
//font-bold text-l
    const header = (
        <div className='flex flex-col mt-2'>
            <div className='flex flex-row text-xl'>
                <div className='px-2 rounded-md flex flex-row' style={{ backgroundColor: `${projectStatusEnum(project.status).color}`}}>
                    {project.name}
                    <div className='ml-2 text-gray-400'>(#{project.tasks.length})</div>
                </div>
                
                {renderDeadline()}
            </div>
        </div>
      );
    const renderTasks = (project) => {
        if(project === undefined || project.tasks === undefined) return
        const minOrder = Math.min(...project.tasks.map(p=>p.order))
        const maxOrder = Math.max(...project.tasks.map(p=>p.order))
        return project.tasks.map((task) => (
            <ExpandableTaskComponent key={task.id} task={task}  isFirst={task.order === minOrder} isLast={task.order === maxOrder}/>
        ))
    }
        
    const renderResources = (project) => {
        if(project === undefined || project.tasks === undefined) return
        return project.resources.map((resource) => (
            <ProjectResourceComponent key={resource.id} projectResource={resource} />
        ))
    }

    const startProjectAction =(async ()=>{
        await projectStart(project.id, changeStatusError)
        refreshProjectsCategory();
    })

    const pauseProjectAction =(async ()=>{
        await projectPause(project.id, changeStatusError)
        refreshProjectsCategory();
    })
    const finishProjectAction =(async ()=>{
        await projectFinish(project.id, changeStatusError)
        refreshProjectsCategory();
    })

    const cancelProjectAction =(async ()=>{
        await projectCancel(project.id, changeStatusError)
        refreshProjectsCategory();
    })


    return (
        <div className='mb-2 bg-ay-100 rounded-lg border-blue-200 border-2'>
            {showProjectModal && editProjectModal}
            {showTaskModal && addTaskModal}
            {showBulkTaskModal && bulkAddTaskModal}
            {showProjectResourceModal && addProjectResourceModal}


            <ExpandablePanel key={project.id} header={header} orderButtons={orderButtons}>
                <ToolbarComponent className='mb-2'>
                    <ToolbarOptionComponent title={'Editar'} size={20} icon={toolbarActions.Edit} clickAction={editProjectAction}/>
                    <ToolbarOptionComponent title={'Iniciar'} size={20} icon={toolbarActions.Start} clickAction={startProjectAction}/>
                    <ToolbarOptionComponent title={'Pausar'} size={20} icon={toolbarActions.Pause} clickAction={pauseProjectAction}/>
                    <ToolbarOptionComponent title={'Finalizar'} size={20} icon={toolbarActions.Finish} clickAction={finishProjectAction}/>
                    <ToolbarOptionComponent title={'Cancelar'} size={20} icon={toolbarActions.Cancel} clickAction={cancelProjectAction}/>
                </ToolbarComponent>

                <Markdown 
                    className='border-l-4 bg-slate-100 pl-2 pr-2 prose max-w-full max-h-60 overflow-y-scroll mb-2'
                    remarkPlugins={[remarkGfm]}
                    >
                        {project.richDescription}
                </Markdown>

                <div className="mb-2">
                    <div className="flex flex-row">
                        <div className='font-bold text-xl mb-2'>Recursos</div>
                        <div className='mt-1'>
                            <ToolbarOptionComponent title={'+ Recurso'} size={20} icon={toolbarActions.AddResource} clickAction={createProjectResourceAction}/>
                        </div>
                    </div>
                {renderResources(project)}
                </div>

                <div className="flex flex-row">
                    <div className="font-bold text-xl mb-2">
                        Tareas
                    </div>
                    <div className="pt-1">
                        <ToolbarOptionComponent title={'+ Task'} size={20} icon={toolbarActions.AddTask} clickAction={addTaskAction}/>
                    </div>
                    <div className="pt-1">
                        <ToolbarOptionComponent title={'+ Lista de tareas'} size={20} icon={toolbarActions.AddBulkTask} clickAction={bulkAddTaskAction}/>
                    </div>

                </div>
                <div className='rounded'>
                    {renderTasks(project)}
                </div>

            </ExpandablePanel>
        </div>
    )
}